import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  withStyles,
} from '@material-ui/core';

const styles = () => ({
  vehicle: {
    fontWeight: 500,
    marginBottom: '8px',
  }
});

const DriverModal = ({onClose, vehicle, classes}) => {
  const actions = [
    <Button
      data-id="close-button"
      key="close-button"
      onClick={onClose}
      variant="text"
    >
      Close
    </Button>
  ];
  // {styles.vehicle}
  return (
    <div>
      <Dialog
        open
        onClose={onClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <DialogContentText classes={{root: classes.vehicle}}>
              Vehicle <span data-id="vehicle-call-name">{vehicle.callName}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>

    </div>
  );
};

DriverModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  vehicle: PropTypes.shape({
    callName: PropTypes.string.isRequired,
  }).isRequired,
  classes: PropTypes.object,
};

export default withStyles(styles)(DriverModal);



// WEBPACK FOOTER //
// ./src/ondemand/components/DriverModal/DriverModal.js